import { render } from "./Section2.vue?vue&type=template&id=9a59deb6&scoped=true"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"

import "./Section2.vue?vue&type=style&index=0&id=9a59deb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a59deb6"]])

export default __exports__